import toast, { Toaster } from "react-hot-toast";

export function Message() {
  const message = () =>
    toast((t) => (
      <div
        style={{ height: 55, width: "100vw" }}
        className={`${t.visible ? "animate-enter" : "animate-leave"} `}
      >
        <div className="d-inline-block">
          <img
            className="card-img-top"
            style={{
              width: 60,
              borderRadius: 50,
              marginTop: -3,
              marginLeft: -13,
            }}
            src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixqx=6GHAjsWpt9&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2.2&w=160&h=160&q=80"
            alt=""
          />
        </div>

        <div
          className="position-absolute d-inline-block"
          style={{ left: "25%" }}
        >
          <div className="user-name">
            <p className="fw-bolder">Gabriela Oliveira</p>
          </div>
          <div className="message text-gray-500">
            <p>Ótimo! 8:30 estou ai para assinar o contrato!</p>
          </div>
        </div>

        <div className="position-absolute d-inline border-l border-gray-200 top-0 end-0">
          <button
            style={{ backgroundColor: "white", margin: 10 }}
            onClick={() => toast.dismiss(t.id)}
            className="border border-transparent rounded-none"
          >
            <i className="bi bi-x-lg"></i>
          </button>
        </div>
      </div>
    ));

  return (
    <div>
      <Toaster position="bottom-right" reverseOrder={false} />

      <button
        className="btn btn-sm btn-light border border-dark fw-bold"
        onClick={message}
      >
        Teste de Notificação
      </button>
    </div>
  );
}
